export const RouteConstants = {
    Home: '/home',
    Shop: '/shop',
    Catering: '/catering',
    Orders: '/orders',
    Checkout: '/checkout',
    Deals: '/deals',
    Offers: '/offers',
    UserAccount: '/user-account',
    OrderStatus: '/order-status',
    ReferAFriend: '/referafriend',
    SubscriptionInfo: '/7NowGoldPass',
    StoreContactInfo: '/contact-us',
    Faqs: '/FAQs',
    DrawerAccount: '/drawer-account',
    DrawerBasket: '/drawer-basket',
}
